import { render, staticRenderFns } from "./form-cellphone.vue?vue&type=template&id=d1e88568&"
import script from "./form-cellphone.vue?vue&type=script&lang=js&"
export * from "./form-cellphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports